import { render, staticRenderFns } from "./NoData.vue?vue&type=template&id=36e7fa6e&scoped=true&"
import script from "./NoData.vue?vue&type=script&lang=js&"
export * from "./NoData.vue?vue&type=script&lang=js&"
import style0 from "./NoData.vue?vue&type=style&index=0&id=36e7fa6e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36e7fa6e",
  null
  
)

export default component.exports